import React from 'react';

export default ({children = 'Page Not Found.'}) => (
	<div className='Error404'>
		<h2>{children}</h2>
	</div>
);